export default (props, vars) =>
  vars?.['applicationcard2']?.['item'].getDescriptionComponent(
    vars?.['applicationcard2']?.['item'].current_step
  );
